import { PageModal } from './AccountModal'
import { FormAssignShoes } from './FormAssignShoe'

export const AssignShoesModal = ({
  childrenProfiles,
  unassignedItems,
  isActive,
  handleToggle,
  handleRefetch,
  children
}) => {
  return (
    <PageModal
      props={{
        modalTitle: 'Assign Shoes',
        isActive,
        handleToggle,
        modal: (
          <FormAssignShoes
            profileChildren={childrenProfiles}
            handleToggle={handleToggle}
            handleRefetch={handleRefetch}
            shoes={unassignedItems}
          />
        )
      }}
    >
      {children}
    </PageModal>
  )
}
